class MegaMenuInteractive {
  constructor(root) {
    this.root = root;
    this.triggers = Array.from(this.root.querySelectorAll('[data-category-trigger]'));
    this.panels = Array.from(this.root.querySelectorAll('[data-category-panel]'));
    this.closeTimer = null;

    if (!this.triggers.length || !this.panels.length) return;

    this.bindEvents();
  }

  bindEvents() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => this.activateCategory(trigger.dataset.categoryTrigger));
      trigger.addEventListener('focus', () => this.activateCategory(trigger.dataset.categoryTrigger));
    });

    this.root.addEventListener('mouseenter', () => this.open());
    this.root.addEventListener('mouseleave', () => this.scheduleClose());
    this.root.addEventListener('focusin', () => this.open());
    this.root.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!this.root.contains(document.activeElement)) {
          this.scheduleClose();
        }
      }, 0);
    });

    this.root.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.root.classList.contains('is-open')) {
        this.scheduleClose();
        const trigger = this.root.querySelector('[aria-expanded]');
        if (trigger) trigger.focus();
      }
    });
  }

  open() {
    window.clearTimeout(this.closeTimer);
    this.root.classList.add('is-open');
    const trigger = this.root.querySelector('[aria-expanded]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  scheduleClose() {
    window.clearTimeout(this.closeTimer);
    this.closeTimer = window.setTimeout(() => {
      this.root.classList.remove('is-open');
      const trigger = this.root.querySelector('[aria-expanded]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }, 120);
  }

  activateCategory(handle) {
    if (!handle) return;
    this.open();

    this.triggers.forEach((trigger) => {
      trigger.classList.toggle('is-active', trigger.dataset.categoryTrigger === handle);
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.categoryPanel === handle);
    });
  }
}

class I18nPickerInteractive {
  constructor(picker) {
    this.picker = picker;
    this.summary = picker.querySelector('summary');
    this.closeTimer = null;

    this.picker.addEventListener('mouseenter', () => {
      clearTimeout(this.closeTimer);
      this.open();
    });

    this.picker.addEventListener('mouseleave', () => {
      this.closeTimer = setTimeout(() => this.close(), 120);
    });

    this.summary.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggle();
    });

    this.summary.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.toggle();
      }
    });

    this.picker.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.picker.hasAttribute('open')) {
        this.close();
        this.summary.focus();
      }
    });

    document.addEventListener('click', (e) => {
      if (!this.picker.contains(e.target)) {
        this.close();
      }
    });
  }

  open() {
    this.picker.setAttribute('open', '');
  }

  toggle() {
    if (this.picker.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  close() {
    clearTimeout(this.closeTimer);
    this.picker.removeAttribute('open');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mega-menu]').forEach((node) => {
    new MegaMenuInteractive(node);
  });

  document.querySelectorAll('.header-i18n-picker').forEach((node) => {
    new I18nPickerInteractive(node);
  });
});
